
import React from 'react';
import { useApp } from '../context/AppContext';
import BottomNavigation from './BottomNavigation';
import Welcome from './screens/Welcome';
import Login from './screens/Login';
import Register from './screens/Register';
import VerifyEmail from './screens/VerifyEmail';
import Dashboard from './screens/Dashboard';
import KycVerification from './screens/KycVerification';
import Transaction from './screens/Transaction';
import TransactionConfirmation from './screens/TransactionConfirmation';
import AtmQrCode from './screens/AtmQrCode';
import AtmMap from './screens/AtmMap';
import History from './screens/History';
import Settings from './screens/Settings';
import InstallPwaPrompt from './InstallPwaPrompt';
import { usePwaInstall } from '../hooks/use-pwa-install';
import { useIsMobile } from '../hooks/use-mobile';
import DesktopBlockingScreen from './DesktopBlockingScreen';

const APP_URL = 'https://coinprime.apps.codemotion.us/';

const MobileApp: React.FC = () => {
  const { currentScreen, isAuthenticated } = useApp();
  const { showInstallPrompt, closePrompt } = usePwaInstall();
  const isMobile = useIsMobile();

  // If not on mobile, show blocking screen
  if (isMobile === false) {
    return <DesktopBlockingScreen appUrl={APP_URL} />;
  }

  const renderScreen = () => {
    switch (currentScreen) {
      case 'welcome':
        return <Welcome />;
      case 'login':
        return <Login />;
      case 'register':
        return <Register />;
      case 'verify-email':
        return <VerifyEmail />;
      case 'dashboard':
        return <Dashboard />;
      case 'kyc':
        return <KycVerification />;
      case 'transaction':
        return <Transaction />;
      case 'transaction-confirmation':
        return <TransactionConfirmation />;
      case 'atm-qr':
        return <AtmQrCode />;
      case 'atm-map':
        return <AtmMap />;
      case 'history':
        return <History />;
      case 'settings':
        return <Settings />;
      default:
        return <Welcome />;
    }
  };

  return (
    <div className="mobile-container">
      {showInstallPrompt && <InstallPwaPrompt onClose={closePrompt} />}
      <div className={`mobile-screen ${isAuthenticated ? 'pb-16' : ''}`}>
        <div className="mobile-status-bar"></div>
        {renderScreen()}
      </div>
      {isAuthenticated && <BottomNavigation />}
    </div>
  );
};

export default MobileApp;
